import { russianDefaultPaymentCards } from "app/constants/CurrencyConstants";

export const reducer: typeof window.kinosite.reducer = {
	cinema: {
		address: 'ул. Набережная Адмирала Серебрякова, д. 53',
		place: null,
		phoneNumbers: ['+7 (8617) 71-52-07'],
		facebook: null,
		instagram: null,
		vk: 'https://vk.com/cinema_neptun',
		twitter: null,
		odnoklassniki: 'https://ok.ru/kinoteatr.neptun',
		youtube: null,
		app: {
			appstore: 'https://apps.apple.com/us/app/кинотеатр-нептун/id1483750276?l=ru&ls=1',
			googleplay: 'https://play.google.com/store/apps/details?id=ru.kinoplan.cinema.neptun',
		},
		payment: {
			active: true,
			card: russianDefaultPaymentCards,
		},
		maps: 'https://yandex.ru/maps/-/CBBAqFXBKC',
		selectButton: {
			options: [],
			selectedOptionValue: null,
		},
		soonPageIsEnabled: false,
	},
	feedback: true,
};
